// Port of api/fuel/app/classes/controller/api/monty/users/suggest.php
import DB from 'offline/db'
import Util from 'offline/util'
export default function(params) {
	var text = (params.text || '').toLowerCase()
	var exclude = params.exclude || [0]
	if (!text) return Promise.resolve({ session: { offline: true }, data: { suggestions: {} } })
	var rows = DB.query("SELECT user_id, user_name, user_firstname, user_lastname, user_avatar FROM user WHERE (LOWER(user_name) LIKE '%" + text.replace(/'/g, "''") + "%' OR LOWER(user_firstname) LIKE '%" + text.replace(/'/g, "''") + "%' OR LOWER(user_lastname) LIKE '%" + text.replace(/'/g, "''") + "%') AND user_id NOT IN(" + Util.in(exclude) + ") LIMIT 25")
	var suggestions = {}
	for (var i = 0; i < rows.length; i++) {
		var u = rows[i]
		suggestions[u.user_id] = { id: u.user_id, name: u.user_name, firstname: u.user_firstname, lastname: u.user_lastname, avatar: u.user_avatar }
	}
	return Promise.resolve({ session: { offline: true }, data: { suggestions: suggestions } })
}
